import React, { FC } from 'react'

import StylesModule from 'layout/top.module.scss'

import SEO from 'components/seo'
import Movie from 'components/lv1/movie'
import DesignButton from 'components/lv1/designButton'
import SquareBg from 'components/lv2/squareBG'
import ImageGrid from 'components/lv2/imageGrid'
import NumHeadlineText from 'components/lv2/NumHeadlineText'
import TopImage from 'components/lv3/topImage'
import TopBgImage from 'components/lv3/topBgImage'

import TopOverview01Img from 'images/top/overview01.jpg'
import TopOverview02Img from 'images/top/overview02.jpg'
import TopOverview03Img from 'images/top/overview03.jpg'
import TopRooms01Img from 'images/top/rooms01.jpg'
import TopRooms02Img from 'images/top/rooms02.jpg'
import TopRooms03Img from 'images/top/rooms03.jpg'
import TopService01Img from 'images/top/service01.jpg'
import TopService01MbImg from 'images/top/service01mb.jpg'
import TopService02Img from 'images/top/service02.jpg'
import TopService03Img from 'images/top/service03.jpg'
import TopGarnishings01Img from 'images/top/garnishings01.jpg'
import TopGarnishings02Img from 'images/top/garnishings02.jpg'
import TopGarnishings03Img from 'images/top/garnishings03.jpg'
import TopGarnishings04Img from 'images/top/garnishings04.jpg'

import { MessageProps } from 'message/index.props'
export interface TopPageProps {
  message: MessageProps
  lang: string
}

const TopPage: FC<TopPageProps> = ({ message, lang }) => {
  return (
    <section className={StylesModule.top}>
      <SEO title={message.top.page_title} lang={lang} />
      <TopImage message={message} lang={lang} />
      <TopBgImage message={message} lang={lang} />
      {/* 1 */}
      <section>
        <NumHeadlineText
          num={message.top.contents1.num}
          headline={message.top.contents1.title}
          text={message.top.contents1.text}
        />
        <div className="mt-24 mt-tb-40">
          <SquareBg addClassName="topMovie">
            <Movie title={message.top.page_title} />
          </SquareBg>
        </div>
      </section>
      {/* 2 */}
      <section className="mt-64 mt-tb-80">
        <NumHeadlineText
          num={message.top.contents2.num}
          headline={message.top.contents2.title}
          text={message.top.contents2.text}
        />
        <div className={StylesModule.layoutButton}>
          <DesignButton
            label={message.global.detail}
            to="../overview/index.html"
            design="outline"
          />
        </div>
        <div className="mt-32 mt-tb-40">
          <SquareBg addClassName="topOverview">
            <ImageGrid addClassName="normal">
              <img src={TopOverview01Img} area-hidden="true" alt="" />
              <img src={TopOverview02Img} area-hidden="true" alt="" />
              <img src={TopOverview03Img} area-hidden="true" alt="" />
            </ImageGrid>
          </SquareBg>
        </div>
      </section>
      {/* 3 */}
      <section className="mt-64 mt-tb-80">
        <NumHeadlineText
          num={message.top.contents3.num}
          headline={message.top.contents3.title}
          text={message.top.contents3.text}
        />
        <div className={StylesModule.layoutButton}>
          <DesignButton
            label={message.global.detail}
            to="../rooms/index.html"
            design="outline"
          />
        </div>
        <div className="mt-32 mt-tb-40">
          <SquareBg addClassName="topRooms">
            <ImageGrid addClassName="normal">
              <img src={TopRooms01Img} area-hidden="true" alt="" />
              <img src={TopRooms02Img} area-hidden="true" alt="" />
              <img src={TopRooms03Img} area-hidden="true" alt="" />
            </ImageGrid>
          </SquareBg>
        </div>
      </section>
      {/* 4 */}
      <section className="mt-64 mt-tb-80">
        <NumHeadlineText
          num={message.top.contents4.num}
          headline={message.top.contents4.title}
          text={message.top.contents4.text}
        />
        <div className={StylesModule.layoutButton}>
          <DesignButton
            label={message.global.detail}
            to="../service/index.html"
            design="outline"
          />
        </div>
        <div className="mt-32 mt-tb-40">
          <SquareBg addClassName="topService">
            <ImageGrid addClassName="rooms">
              <div>
                <img
                  src={TopService01Img}
                  className="mb-hidden"
                  area-hidden="true"
                  alt=""
                />
                <img
                  src={TopService01MbImg}
                  className="tb-pc-hidden"
                  area-hidden="true"
                  alt=""
                />
              </div>
              <img src={TopService02Img} area-hidden="true" alt="" />
              <img src={TopService03Img} area-hidden="true" alt="" />
            </ImageGrid>
          </SquareBg>
        </div>
      </section>
      <hr className="bar mt-tb-120 mb-hidden" />
      {/* 佳水園が織りなすあしらい */}
      <section className="mt-64 mt-tb-80">
        <div className={StylesModule.hospitality}>
          <h1 className={StylesModule.hospitality__title}>
            {message.top.hospitality.title}
          </h1>
          <div className={StylesModule.hospitality__text}>
            {message.top.hospitality.text}
          </div>
          <div className="mt-32 mt-tb-40">
            <div className={StylesModule.hospitality__images}>
              <img src={TopGarnishings01Img} area-hidden="true" alt="" />
              <img src={TopGarnishings02Img} area-hidden="true" alt="" />
              <img src={TopGarnishings03Img} area-hidden="true" alt="" />
              <img src={TopGarnishings04Img} area-hidden="true" alt="" />
            </div>
          </div>
        </div>
      </section>
    </section>
  )
}

export default TopPage
